import * as company from '../config/company'

/**
 *  TODO
 *
 *  @param  {string} companyName [postcode already preapproved on form]
 *  @method POST
 */
export function companyNameSearch(companyName: string) {

    const body = {
        authentication: {
            apiUserId: company.default.apiUserId,
            apiUserKey: company.default.apiUserKey,
        },
        request: {
            CompanyName: companyName,
        },
    }

    return {
        type: 'FIND_COMPANY_NAMES',
        payload: fetch(`${company.default.baseUrl}`, { method: 'POST', body: JSON.stringify(body) })
            .then(response => response.json()),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/company.ts